import {BaseConverter} from '../../base/converters/base-converter.converter';
import {UnitModel} from '../models/unit.model';
import {Unit} from '../DTO/unit';
import {Injectable} from '@angular/core';

@Injectable()
export class UnitConverter extends BaseConverter<UnitModel, Unit> {
  convertToDto(model: UnitModel): Unit {
    if (!model) {
      return;
    }
    return {
      accountCode: model.accountCode,
      code: model.code,
      customerCode: model.customerCode,
      description: model.description,
      father: this.convertToDto(model.father),
      structure: this.convertToDtoList(model.structure),
      treeAccountCode: model.treeAccountCode,
      treeCustomerCode: model.treeCustomerCode
    };
  }

  convertToModel(dto: Unit): UnitModel {
    if (!dto) {
      return;
    }
    let model: UnitModel = new UnitModel();
    model.description = dto.description;
    model.customerCode = dto.customerCode;
    model.code = dto.code;
    model.accountCode = dto.accountCode;
    model.treeCustomerCode = dto.treeCustomerCode;
    model.treeAccountCode = dto.treeAccountCode;
    model.structure = this.convertToModelList(dto.structure);
    model.father = this.convertToModel(dto.father);
    return model;
  }

}
